<template>
  <div class="bottom-nav">
    <div :class="['nav-btn', isActive('/home') && 'active']" @click="$router.push('/home')">
      <span class="icon">🚗</span>
      <span>月卡车辆</span>
    </div>
    <div :class="['nav-btn', isActive('/coupon') && 'active']" @click="$router.push('/coupon')">
      <span class="icon">🎫</span>
      <span>优惠管理</span>
    </div>
    <div :class="['nav-btn', isActive('/profile') && 'active']" @click="$router.push('/profile')">
      <span class="icon">👤</span>
      <span>个人中心</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BottomNav',
  methods: {
    isActive (prefix) {
      return this.$route.path.indexOf(prefix) === 0
    }
  }
}
</script>

<style scoped>
.bottom-nav {
  position: fixed;
  left: 0; right: 0; bottom: 0;
  width: 100vw;
  max-width: 430px;
  margin: 0 auto;
  background: #fff;
  border-top: 1.5px solid #eee;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 60px;
  z-index: 10;
}

.nav-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #888;
  font-size: 13px;
  cursor: pointer;
  transition: color 0.2s;
  font-weight: 500;
}

.nav-btn.active {
  color: #3572e6;
  font-weight: bold;
}

.nav-btn .icon {
  font-size: 26px;
  margin-bottom: 2px;
}
</style>
